import { useParams, useSearchParams } from 'react-router-dom';
import {
  useGetProposalsListQuery,
  ProposalItem,
} from '@/store/services/biddingProposalsService';
import PostList from './PostList';
import ProposalCardSkeleton from './skeletons/ProposalCardSkeleton';
import EmptyState from '@/components/atoms/EmptyState';
import { Pagination } from 'antd';

export type Proposal = ProposalItem;

export default function PostsListWrapper() {
  const params = useParams<{ postId: string }>();
  const [searchParams, setSearchParams] = useSearchParams();
  const page = searchParams.get('page') || '1';
  const sort = searchParams.get('sort') || undefined;

  const { data, isLoading } = useGetProposalsListQuery(
    {
      postId: params.postId as string,
      page,
      sort,
    },
    {
      skip: !params.postId,
    }
  );

  const handlePageChange = (newPage: number) => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set('page', newPage.toString());
    setSearchParams(nextParams);
  };

  const content = data?.payload?.content ?? [];
  const totalElements = data?.payload?.totalElements ?? 0;

  return (
    <div className="" data-testid="post-details-proposals-list-wrapper">
      {isLoading ? (
        <div
          className="space-y-5"
          data-testid="post-details-proposals-skeleton-list"
        >
          <ProposalCardSkeleton withActions withPadding />
          <ProposalCardSkeleton withActions withPadding />
        </div>
      ) : (
        <PostList proposals={content} />
      )}

      {totalElements > 10 && (
        <div
          className="flex justify-center items-center mt-6 pt-4 border-t border-light-input-border dark:border-dark-input-border"
          data-testid="post-details-proposals-pagination"
        >
          <Pagination
            current={Number(page) || 1}
            total={totalElements}
            pageSize={10}
            onChange={handlePageChange}
            showSizeChanger={false}
            hideOnSinglePage={true}
          />
        </div>
      )}

      {totalElements === 0 && !isLoading && (
        <div data-testid="post-details-proposals-empty">
          <EmptyState disableDesc />
        </div>
      )}
    </div>
  );
}
